import React, { useState } from "react";
import { AllCategoriesAPI } from "../API/Dashboard/AllCategories";
import TabsSection from "../Tabs/TabsSection";
import NoDataText from "../NoDataText";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination/Pagination";
import swal from "sweetalert";

const DashboardAllCategories = (props) => {
  const {
    AllTableData,
    setAllTableData,
    setLoading,
    PageCount,
    SetPageNumber,
  } = props;

  const [sortFlag, setSortFlag] = useState(1);

  const navigate = useNavigate();

  const ApiAllCategories = async (column) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      column_name: column,
      limit: 10,
      offset: 0,
      sort_type: sortFlag,
    };

    const coupondetailData = await AllCategoriesAPI(data, () => {
      navigate("/");
    });
    setLoading(false);
    if(coupondetailData.status == 429){
      swal({
        // title: "Error!",
        title: coupondetailData.message,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
      setLoading(true)
    }else{
      setAllTableData(coupondetailData?.all_categories);
    }
   
  };

  return (
    <>
      <div className="acc-dashboard mt-4">
        <TabsSection />
        <div class="table-responsive-xl black-header dashboard-Table">
          <table class="recentact-table mt-3 table ver-middle manage-vou-table">
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Business Category</th>
                <th>New Requests</th>
                <th>In-Review</th>
                <th>Published</th>
                <th>Declined</th>
              </tr>
            </thead>
            <tbody>
              {AllTableData.length != 0 ? (
                <>
                  {AllTableData?.map((item, key) => {
                    return (
                      <tr>
                        <td style={{ textAlign: "left" }}>
                          {item.category_name}
                        </td>
                        <td>{item.new}</td>
                        <td>{item.in_review}</td>
                        <td>{item.published}</td>
                        <td>{item.declined}</td>
                      </tr>
                    );
                  })}
                </>
              ) : (
                <tr class="toggle-row">
                  <td colspan="8">
                    <p class="noData">{NoDataText.ErrText}</p>{" "}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {PageCount > 10 ? (
        <Pagination
          totalPageCount={PageCount}
          setPageNumber={SetPageNumber}
          limit={10}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default DashboardAllCategories;
